import { Layout, Result } from 'antd';
import React from 'react';
import { Container } from './styles';

const NaoAutorizado: React.FC = () => {
  return (
    <>
      <Layout>
        <Container>
          <Result status="403" title="Desculpe, você não está autorizado a acessar esta página." />
        </Container>
      </Layout>
    </>
  );
};

export default NaoAutorizado;
